/* eslint-disable consistent-return */
const react = require('react');
const lunr = require('lunr');

const useLunr = (query, rawIndex, rawStore) => {
  const index = react.useMemo(() => {
    if (
      rawIndex === undefined ||
      rawIndex === null ||
      Object.keys(rawIndex).length === 0
    )
      return;

    if (rawIndex instanceof lunr.Index) return rawIndex;
    if (typeof rawIndex === 'string')
      return lunr.Index.load(JSON.parse(rawIndex));
    if (typeof rawIndex === 'object') return lunr.Index.load(rawIndex);
  }, [rawIndex]);
  const store = react.useMemo(() => {
    if (typeof rawStore === 'string') return JSON.parse(rawStore);
    return rawStore;
  }, [rawStore]);
  return react.useMemo(() => {
    if (!query || !index) return [];
    // clean query params away from the lunrjs modifiers
    const results =
      typeof query === 'string'
        ? index.search(query.replace(/[&/\\#,+()$~%.'":*\-^<>{}]/g, ''))
        : index.query(query.replace(/[&/\\#,+()$~%.'":*\-^<>{}]/g, ''));
    if (store)
      return results.map(_ref => {
        const { ref } = _ref;
        return store[ref];
      });
    return results;
  }, [query, index, store]);
};

export default useLunr;
